import React, { Component } from "react"
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import { connect } from "react-redux"
import { Redirect, Link } from 'react-router-dom'
import share_apple_img from '../../utils/assets/images/share-apple.png'
import REGLEMENT_PARRAINAGE  from '../../utils/assets/pdf/REGLEMENT_PARRAINAGE.pdf'
import Dashboard from '../Dashboard'
import StatBox from '../../components/StatBox'
import ParrainLink from '../../components/ParrainLink'
import { fetchReauthenticateMembersAction } from  '../../actions/Authentification/Reauthenticate'
import { fetchAllClicksAction, fetchAllSouscriptionsAction, fetchWeekSouscriptionsAction, fetchActivatedPoliciesAction } from  '../../actions/Parrain'

class Parrain extends Component {
  componentDidMount() {
    document.title = `Dashboard Membre | Parrain`

    const { reauthenticateMembers,
            getReauthenticate,
            userGetAllClicks,
            userGetAllSouscriptions,
            userGetWeekSouscriptions,
            userGetActivatedPolicies
          } = this.props
    if (Object.keys(reauthenticateMembers.userData).length === 0) {
      getReauthenticate()
    }
    if (reauthenticateMembers.userData.userCode) {
      userGetAllClicks(reauthenticateMembers.userData.userCode)
      userGetAllSouscriptions(reauthenticateMembers.userData.userCode)
      userGetWeekSouscriptions(reauthenticateMembers.userData.userCode)
      userGetActivatedPolicies(reauthenticateMembers.userData.userCode)
    }
  }
  componentWillUpdate(nextProps, nextState) {
    const { reauthenticateMembers,
            userGetAllClicks,
            userGetAllSouscriptions,
            userGetWeekSouscriptions,
            userGetActivatedPolicies
          } = nextProps

    if (reauthenticateMembers.userData.length !== this.props.reauthenticateMembers.userData.length) {
      if (reauthenticateMembers.userData.userCode) {
        userGetAllClicks(reauthenticateMembers.userData.userCode)
        userGetAllSouscriptions(reauthenticateMembers.userData.userCode)
        userGetWeekSouscriptions(reauthenticateMembers.userData.userCode)
        userGetActivatedPolicies(reauthenticateMembers.userData.userCode)
      }
    }
  }

  render() {
    const { match,
            reauthenticateMembers,
            getAllClicks,
            getAllSouscriptions,
            getWeekSouscriptions,
            getActivatedPolicies
          } = this.props

    return (
      <div>
        <Header userIsSuccessLogin={reauthenticateMembers.isSuccess} />
          {reauthenticateMembers.isLoading
            ?
              <div className="aps-spinner-container-loading">
                <div className="uk-spinner">
                  <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 30 30" ratio="1">
                     <circle fill="none" stroke="#AEC340" cx="15" cy="15" r="14"></circle>
                  </svg>
                </div>
                <div className="aps-section-register-desc">chargement en cours</div>
              </div>
            :
              <Dashboard match={match}>
                <div>
                  {reauthenticateMembers.userData.userCode &&
                    (
                      <ParrainLink userName={reauthenticateMembers.userData.lastname} userCode={reauthenticateMembers.userData.userCode} />
                    )
                  }
                  <div className="aps-dashboard-body-divider"></div>
                  <div className="aps-dashboard-body-second-reglement-content">
                    <Link className="aps-section-status-content-full-lien" target="_blank" to={REGLEMENT_PARRAINAGE}>
                      <div className="uk-card-hover">
                        <p className="uk-text-center" style={{margin: "0"}}>
                          <img className="aps-section-status-share-apple" src={share_apple_img} alt="fi-alert" />
                          <span className="aps-section-status-content-full">
                            Télécharger le règlement parrainage
                          </span>
                        </p>
                      </div>
                    </Link>
                  </div>
                  <div className="aps-dashboard-body-divider"></div>
                </div>
                {(getAllClicks.isLoading || getAllSouscriptions.isLoading || getWeekSouscriptions.isLoading || getActivatedPolicies.isLoading)
                  ?
                    <div className="aps-spinner-component-loading">
                      <div className="uk-spinner">
                        <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 30 30" ratio="1">
                           <circle fill="none" stroke="#AEC340" cx="15" cy="15" r="8"></circle>
                        </svg>
                      </div>
                      <div className="aps-section-register-desc">chargement en cours</div>
                    </div>
                  :
                    <div>
                      <div className="aps-dashboard-body-second-stats-content">
                        <div className="aps-dashboard-body-stats-container-title">
                          <p className="uk-text-center aps-dashboard-body-stats-title">
                            Statistiques
                          </p>
                        </div>
                        <div data-uk-grid>
                          {getAllClicks.allClicksData.length !== 0 &&
                            (
                              <StatBox title={"Inscription(s) via ce lien"} subtitle={"au total"} number={getAllClicks.allClicksData.total} color={"#725CA4"}/>
                            )
                          }
                          {getWeekSouscriptions.weekSouscriptionsData.length !== 0 &&
                            (
                              <StatBox title={"Souscription(s) envoyée(s)"} subtitle={"cette semaine"} number={getWeekSouscriptions.weekSouscriptionsData.total} color={"#04AEE6"}/>
                            )
                          }
                          {getAllSouscriptions.allSouscriptionsData.length !== 0 &&
                            (
                              <StatBox title={"Souscription(s) envoyée(s)"} subtitle={"au total"} number={getAllSouscriptions.allSouscriptionsData.total} color={"#EBB763"}/>
                            )
                          }
                          {getActivatedPolicies.activatedPoliciesData.length !== 0 &&
                            (
                              <StatBox title={"Police(s) activée(s)"} subtitle={""} number={getActivatedPolicies.activatedPoliciesData.total} color={"#9AB616"}/>
                            )
                          }
                        </div>
                      </div>
                    </div>
                }
                {reauthenticateMembers.isError &&
                  <div>
                    <Redirect to='/connexion' push/>
                  </div>
                }
              </Dashboard>
          }
        <Footer/>
      </div>
    )
  }
}

const mapStateToProps = ({ reauthenticateMembers, getAllClicks, getAllSouscriptions, getWeekSouscriptions, getActivatedPolicies }) => {
  return {
    reauthenticateMembers,
    getAllClicks,
    getAllSouscriptions,
    getWeekSouscriptions,
    getActivatedPolicies,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    getReauthenticate: () => dispatch(fetchReauthenticateMembersAction()),
    userGetAllClicks: (codeParrain) => dispatch(fetchAllClicksAction(codeParrain)),
    userGetAllSouscriptions: (codeParrain) => dispatch(fetchAllSouscriptionsAction(codeParrain)),
    userGetWeekSouscriptions: (codeParrain) => dispatch(fetchWeekSouscriptionsAction(codeParrain)),
    userGetActivatedPolicies: (codeParrain) => dispatch(fetchActivatedPoliciesAction(codeParrain)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Parrain)



// WEBPACK FOOTER //
// ./src/containers/Parrain/index.js